import * as currency from "./currency.js";

if (!customElements.get("x-configurator")) {
  class Configurator extends HTMLElement {
    constructor() {
      super();

      this.state = [];

      this.url = this.getAttribute("url");
      this.format = this.getAttribute("money_format");

      this.addToCart = this.querySelector("button#add-to-cart");

      this.sectionId = this.getAttribute("section_id");
      this.forms = this.querySelectorAll("form");

      this.radios = this.querySelectorAll("input[type='radio']");

      this.preloads = this.querySelector("#configurator-preloads");

      this.syncRadioParent = this.querySelectorAll("input[data-sync-parent]");
      this.syncRadioChild = this.querySelectorAll("input[data-sync-child]");

      this.radioGroups = this.querySelectorAll(".radio-group");
      this.filterPanels = this.querySelectorAll("[data-filter]");

      this.uiCap = this.querySelector(".price-cap");
      this.uiRp = this.querySelector(".price-rp");

      // BUMPER
      this.bumperImage = this.querySelector("#configurator-bumper");
      this.bumperTitle = this.querySelector(".bumper-selected-variant-title");
      this.bumperPrice = this.querySelector(".bumper-selected-variant-price");
      this.bumperCompare = this.querySelector(
        ".bumper-selected-variant-compare"
      );
      this.bumperRadiosContainer = this.querySelector(".bumper-radios");
      this.bumperRadios = this.querySelectorAll(".bumper-radio");
      this.withBumper = this.querySelector(
        "input[type='radio'][name='bumper'][value='has-bumper']"
      );
      this.withoutBumper = this.querySelector(
        "input[type='radio'][name='bumper'][value='no-bumper']"
      );
    }

    // SYNC RADIOS
    handleSyncRadios = (e) => {
      e.preventDefault();
      this.syncRadioChild.forEach((radio) => {
        if (radio.value == e.target.value) {
          radio.checked = true;
        }
      });
    };

    switchProductImage = (clickedElement) => {
      if (clickedElement.dataset.type) {
        // GET TARGET & SOURCE
        const target = this.querySelector(
          `#configurator-${clickedElement.dataset.type}`
        );
        const source = this.preloads.querySelector(
          `[data-id="${clickedElement.value}"]`
        );

        // REPLACING TARGET SRC & SRCSET WITH SOURCE SRC & SRCSET
        target.setAttribute("src", source.getAttribute("src"));
        target.setAttribute("srcset", source.getAttribute("srcset"));
      }
    };

    updateUIPrice = () => {
      const selectedElementsPrices = [];
      this.querySelectorAll([
        "input[type='radio'][data-cap][data-rp]:checked",
      ]).forEach((el) => {
        selectedElementsPrices.push({
          cap: el.dataset.cap ? el.dataset.cap : el.dataset.rp,
          rp: el.dataset.rp,
        });
      });

      const cap_price = selectedElementsPrices.reduce((sum, current) => {
        return sum + parseInt(current.cap);
      }, 0);

      const rp_price = selectedElementsPrices.reduce((sum, current) => {
        return sum + parseInt(current.rp);
      }, 0);

      console.log("cap_price: ", cap_price);
      console.log("rp_price: ", rp_price);

      if (cap_price == rp_price) {
        this.uiCap.classList.add("tw-hidden");
      } else {
        this.uiCap.classList.remove("tw-hidden");
      }

      this.uiCap.innerHTML = currency.formatMoney(cap_price, this.format);
      this.uiRp.innerHTML = currency.formatMoney(rp_price, this.format);
    };

    handleChange = (e) => {
      // SIZE RADIOS
      if (e.target.classList.contains("size-radio")) {
        const filter = e.target.value;

        this.filterPanels.forEach((filterPanel) => {
          if (filterPanel.dataset.filter == filter) {
            filterPanel.classList.remove("hidden");

            const firstAvailable = filterPanel.querySelector(
              'input[type="radio"]:not(:disabled)'
            );
            firstAvailable.click();
          } else {
            filterPanel.classList.add("hidden");
          }
        });
      }

      // BOTTLE RADIOS
      if (e.target.classList.contains("bottle-radio")) {
        this.state = this.state.filter((item) => item.type != "bottle");
        // SET STATE ADD BUMPER
        this.state.push({
          id: parseInt(e.target.value),
          quantity: parseInt(
            e.target.form.querySelector("input[name='quantity']").value
          ),
          title: e.target.dataset.title,
          type: "bottle",
        });
        this.switchProductImage(e.target);
        this.querySelectorAll(
          ".selected-or-first-available-title_bottle"
        ).forEach((el) => {
          el.innerHTML = "";
        });
        console.log(
          "closest div: ",
          (e.target
            .closest("div")
            .querySelector(
              ".selected-or-first-available-title_bottle"
            ).innerHTML = e.target.dataset.title)
        );
      }

      // DISPENSER RADIOS
      if (e.target.classList.contains("dispenser-radio")) {
        this.state = this.state.filter((item) => item.type != "dispenser");
        // SET STATE ADD BUMPER
        this.state.push({
          id: parseInt(e.target.value),
          quantity: parseInt(
            e.target.form.querySelector("input[name='quantity']").value
          ),
          title: e.target.dataset.title,
          type: "dispenser",
        });
        this.switchProductImage(e.target);
        this.querySelector(
          ".selected-or-first-available-title_pump"
        ).innerHTML = e.target.dataset.title;
      }

      // BUMPER RADIOS
      if (e.target.classList.contains("bumper-radio")) {
        if (e.target.name === "bumper" && e.target.value === "no-bumper") {
          // SELECT NO BUMPER
          // HIDE BUMPER IMAGE & UNCHECK TRUE GROUP & UNCHECK ANY BUMPER RADIOS
          this.bumperRadios.forEach((bumper) => {
            if (bumper != e.target) {
              bumper.checked = false;
            }
          });
          this.bumperImage.classList.add("hidden");
          // CLEAR TITLE & CURRENCY
          this.bumperTitle.innerHTML = "";
          this.bumperPrice.innerHTML = "";
          this.bumperCompare.innerHTML = "";
          // SET STATE REMOVE BUMPER
          this.state = this.state.filter((item) => item.type != "bumper");
        } else if (
          e.target.name === "bumper" &&
          e.target.value === "has-bumper"
        ) {
          // SELECTS WITH BUMPER
          const firstAvailable = this.bumperRadiosContainer.querySelector(
            'input[type="radio"]:not(:disabled)'
          );
          firstAvailable.checked = true;
          this.switchProductImage(e.target);
          if (this.bumperImage.classList.contains("hidden")) {
            this.bumperImage.classList.remove("hidden");
          }
          this.bumperTitle.innerHTML = firstAvailable.dataset.title;
          this.bumperCompare.innerHTML = currency.formatMoney(
            parseInt(firstAvailable.dataset.compare),
            this.format
          );
          this.bumperPrice.innerHTML = currency.formatMoney(
            parseInt(firstAvailable.dataset.price),
            this.format
          );
          // SET STATE ADD BUMPER
          this.state.push({
            id: parseInt(firstAvailable.value),
            quantity: parseInt(
              e.target.form.querySelector("input[name='quantity']").value
            ),
            title: firstAvailable.dataset.title,
            type: "bumper",
          });
        } else if (e.target.name === "id") {
          //  SELECTS BUMPER
          this.withBumper.checked = true;
          this.switchProductImage(e.target);
          if (this.bumperImage.classList.contains("hidden")) {
            this.bumperImage.classList.remove("hidden");
          }
          this.bumperTitle.innerHTML = e.target.dataset.title;
          this.bumperCompare.innerHTML = currency.formatMoney(
            parseInt(e.target.dataset.compare),
            this.format
          );
          this.bumperPrice.innerHTML = currency.formatMoney(
            parseInt(e.target.dataset.price),
            this.format
          );
          if (this.state.find((item) => item.type === "bumper")) {
            this.state = this.state.filter((item) => item.type != "bumper");
            // SET STATE ADD BUMPER
            this.state.push({
              id: parseInt(e.target.value),
              quantity: parseInt(
                e.target.form.querySelector("input[name='quantity']").value
              ),
              title: e.target.dataset.title,
              type: "bumper",
            });
          } else {
            // SET STATE ADD BUMPER
            this.state.push({
              id: parseInt(e.target.value),
              quantity: parseInt(
                e.target.form.querySelector("input[name='quantity']").value
              ),
              title: e.target.dataset.title,
              type: "bumper",
            });
          }
        }
      }

      // WALLMOUNT RADIO
      if (e.target.classList.contains("wall-mount-radio")) {
        if (e.target.value === "no-wall-mount") {
          //  REMOVE WALL MOUNT
          this.state = this.state.filter((item) => item.type != "wall-mount");
        } else {
          //  ADD WALLMOUNT
          if (this.state.find((item) => item.type === "wall-mount")) {
            this.state = this.state.filter((item) => item.type != "wall-mount");
            // SET STATE ADD WALL MOUNT
            this.state.push({
              id: parseInt(e.target.value),
              quantity: parseInt(
                e.target.form.querySelector("input[name='quantity']").value
              ),
              title: e.target.dataset.title,
              type: "wall-mount",
            });
          } else {
            // SET STATE ADD WALLMOUNT
            this.state.push({
              id: parseInt(e.target.value),
              quantity: parseInt(
                e.target.form.querySelector("input[name='quantity']").value
              ),
              title: e.target.dataset.title,
              type: "wall-mount",
            });
          }
        }
      }

      // UPDATE UI PRICE
      this.updateUIPrice();

      // STATE
      // console.log("handleChange() - this.state: ", this.state);

      return;
    };

    getState = () => {
      this.state = window.defaultSettings;
      // console.log("getState() - this.state: ", this.state);
    };

    handleUrl = () => {
      // GET URL SETTINGS PARAMS
      if (!window.location.search == "") {
        const params = new URLSearchParams(window.location.search)
          .get("settings")
          .split(",");

        //  FOR EACH SETTING, SIMULATE CLICK IN CONFIGURATOR
        params.forEach((param) => {
          this.querySelector(`[value="${param}"]`).click();
        });
      }

      return;
    };

    handleAddToCart = (e) => {
      e.preventDefault();

      const items = [];

      this.state.forEach((item) => {
        items.push({
          id: item.id,
          quantity: item.quantity,
        });
      });

      const formData = {
        items: [...items],
      };

      // DISABLE AND LOADING
      this.addToCart.disabled = true;
      this.addToCart.querySelector(".default").classList.add("hidden");
      this.addToCart.querySelector(".loading").classList.remove("hidden");

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            // BANNER
            const bannerElement = document.createRange()
              .createContextualFragment(`
            <div class="banner banner--success" role="alert">
              ${window.themeVariables.strings.addedToCart}
            </div>
          `).firstElementChild;
            this.prepend(bannerElement);
            setTimeout(() => {
              bannerElement.remove();
            }, 2500);

            // DISABLE AND LOADING
            this.addToCart.disabled = false;
            this.addToCart.querySelector(".loading").classList.add("hidden");
            this.addToCart.querySelector(".default").classList.remove("hidden");

            // UPDATE CART BUTTON UI
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );

            // OPEN CART
            document.querySelector("a[aria-controls='cart-drawer']").click();
          }

          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    connectedCallback() {
      // console.log("Configurator connectedCallback");

      this.addToCart.addEventListener("click", this.handleAddToCart.bind(this));

      this.radios.forEach((radio) => {
        radio.addEventListener("click", this.handleChange.bind(this));
      });

      this.syncRadioParent.forEach((radio) => {
        radio.addEventListener("change", this.handleSyncRadios.bind(this));
      });

      this.getState();
      this.handleUrl();

      console.log("STATE: ", this.state);

    }
    disconnectedCallback() {}
  }
  customElements.define("x-configurator", Configurator);
}
